import { html, TemplateResult, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { SlotHelper } from '../../controllers/slot-helper';
import globalStyles from './nuvance-carousel-container.global.pcss?inline';

/**
 * The Nuvance Carousel Container component
 * @element nuvance-carousel-container
 *
 * General container for Outline Carousel.
 * Accounts for carousel having pager and position subheader link accordingly.
 *
 * @slot default - Default slot for this element, should contain outline-carousel.
 * @slot header - Slot for outline-heading.
 * @slot subheader-link - Slot for link below header and inline with outline-carousel paging.
 *
 * @property {boolean} noBackground - Reflects the 'no-background' attribute to toggle background visibility.
 */
@customElement('nuvance-carousel-container')
export class NuvanceCarouselContainer extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
  });

  // SlotHelper instance to manage and test slots
  private slots = new SlotHelper(this);

  /**
   * The following properties are automatically set based on carousel state
   * and used for styling purposes via CSS attribute selectors
   */
  @property({ type: Boolean, reflect: true, attribute: 'no-background' })
  noBackground: boolean;

  render(): TemplateResult {
    return html`
      ${this.slots.isNotEmpty('header')
        ? html`<slot name="header"></slot>`
        : nothing}
      ${this.slots.isNotEmpty('subheader-link')
        ? html`<slot name="subheader-link"></slot>`
        : nothing}
      <slot></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nuvance-carousel-container': NuvanceCarouselContainer;
  }
}
